import { render, staticRenderFns } from "./playlists.vue?vue&type=template&id=0ca577a6&scoped=true&"
import script from "./playlists.vue?vue&type=script&lang=js&"
export * from "./playlists.vue?vue&type=script&lang=js&"
import style0 from "./playlists.vue?vue&type=style&index=0&id=0ca577a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca577a6",
  null
  
)

export default component.exports